import { type PayloadAction, createSlice} from '@reduxjs/toolkit';
import  { type WritableDraft } from 'immer/dist/internal.js';

interface FolderState {
  selectedFolderId: number | null;
}

const initialState: FolderState = {
  selectedFolderId: null,
};

const folderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    setSelectedFolderId(state: WritableDraft<FolderState>, action: PayloadAction<number | null>) {
      state.selectedFolderId = action.payload;
    },
  },
});

export const { setSelectedFolderId } = folderSlice.actions;
export default folderSlice.reducer;
